import { createContext, useContext, useState } from "react";

const ProviderContext = createContext();

export const useLoaderProvider = () => useContext(ProviderContext);

const LoaderProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);

  const updateLoader = (d) => {
    setLoader(d);
  };
  return <ProviderContext.Provider value={{ loader, updateLoader }}>{children}</ProviderContext.Provider>;
};

export default LoaderProvider;
